import React from 'react';
import {Box} from "@material-ui/core";

import {TableMerchant} from '../../../../../helpers/Table/';
import {apiV2KlubcoinFeesList} from "../../../../../../api/merchant/klubcoinFees";

import {reportGenerationParams} from "./constants/reportGenerationParams";
import {columnsList} from "./constants/columnsList";

const getRowsFromServer = (asset_code) => ({offset, limit, ...rest}) => {
  return apiV2KlubcoinFeesList({offset, limit, asset_code, ...rest}).catch((err) => {
    return ({list: [], count: 0});
  });
};

module.exports = ({assetCode, topBlockHeight = 0}) => {
  return (
    <Box width="100%" height={`calc(100vh - ${265 + topBlockHeight}px)`} minHeight="500px">
      <TableMerchant
        hideSearch
        getDataFromServer={getRowsFromServer(assetCode)}
        report={reportGenerationParams(assetCode)}
        columns={columnsList}
        reloadOnPropsChange={assetCode}
      />
    </Box>
  )
}
